<template>
<div>
    <!-- Login Background  -->
    <div class="container-fluid stepsBar">
        <br>
        <br>
        <br>
        <div class="text-center ">
            <div class="loginRegSection" style="max-width: 400px; padding: 30px; margin: 0 auto;">
            <h2 class="mb-4">Reset Password</h2>
            <form class="userFormWrpr text-left mx-auto my-5" @submit.prevent="updatePassword"
                @keydown="form.onKeydown($event)">
                <label class="inputWrpr" :class="{ 'error': form.errors.has('email') ,'haveValue': form.email }">
                    <input v-model="form.email" class="form-control" type="email" name="email" disabled />
                    <span class="label">Email</span>
                    <has-error :form="form" field="email" class="errormsg" />
                </label>
                <label class="inputWrpr"
                    :class="{ 'error': form.errors.has('password') ,'haveValue': form.password }">
                    <input v-model="form.password" class="form-control" type="password" />
                    <span class="label">Password</span>
                    <has-error :form="form" field="password" class="errormsg" />
                </label>
                <label class="inputWrpr"
                    :class="{ 'error': form.errors.has('password_confirmation') ,'haveValue': form.password_confirmation }">
                    <input v-model="form.password_confirmation" class="form-control" type="password" />
                    <span class="label">Confirm New Password</span>
                    <has-error :form="form" field="password_confirmation" class="errormsg" />
                </label>
                <div class="form-group text-center mt-4">
                    <input type="submit" value="UPDATE" class="btn btnSubmit">
                </div>
            </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>

export default {
    name: "Forgot_password",
    components: {

    },
    data() {
        return {
                 form: new Form({
                    password_confirmation:'',
                    password : '',
                    token : this.$route.query.token,
                    email : this.$route.query.email,
                })
            }
    },

    methods: {
         updatePassword(){
             this.form.post('/api/password/reset')
            .then((response)=>{
                if(response.data.success==true){
                if($cookies.isKey('anch_remember_me')){
                    if(this.form.email==$cookies.get('anch_log_email'))
                    this.$cookies.set("anch_log_pass", this.form.password, "340d")
                }
                this.$router.push('/login').catch(() => {});;
            }
            Toast.fire({
                icon: 'success',
                title: response.data.message
            });
            });
      }
    }
}

</script>

<style scoped>

</style>
